import React from 'react';
import './TracknTone.css';
import tracknToneLogo from '../assets/images/trackntone_1024.png';

function TracknToneTerms() {
  return (
    <div className="trackntone-page">
      <section className="trackntone-hero">
        <div className="trackntone-hero-inner">
          <img
            src={tracknToneLogo}
            alt="TracknTone logo"
            className="trackntone-logo-wow trackntone-logo-wow--small"
          />
          <h1>TracknTone Terms of Service</h1>
          <p>Last updated: May 26, 2026</p>
        </div>
      </section>

      <section className="trackntone-content">
        <h2>Terms of Service (plain-language)</h2>
        <p>
          By using TracknTone, you agree to use the app responsibly and in accordance with these
          Terms. TracknTone is designed to support healthy habits and motivation. It is not a
          medical device and does not provide medical treatment.
        </p>

        <h2>Health information and “not medical advice”</h2>
        <p>
          Any suggestions, coaching-style insights, or estimates in the app are for informational
          purposes only. They are not medical advice and are not intended to diagnose, treat,
          cure, or prevent any medical condition. Always consult a qualified healthcare
          professional regarding any health concern.
        </p>

        <h2>Account responsibility</h2>
        <ul>
          <li>You are responsible for maintaining the security of your account and login credentials.</li>
          <li>You agree not to misuse the service or attempt unauthorized access.</li>
        </ul>

        <h2>Circles (opt-in sharing)</h2>
        <p>
          Circles are private groups you create or join. Information you choose to share in a
          Circle becomes visible to other Circle members. You control your sharing choices
          within the app, and you agree to share only information you are comfortable making
          visible to Circle members.
        </p>

        <h2>Disclaimers and limitation of liability</h2>
        <p className="trackntone-disclaimer">
          To the maximum extent permitted by law, NorthHawks Technology and its affiliates make no
          warranties of any kind, express or implied, about the accuracy, reliability, availability,
          or fitness for a particular purpose of the app or website. We are not liable for any
          indirect, incidental, special, consequential, or punitive damages, or for any losses
          related to your use of the app.
        </p>

        <h2>Changes</h2>
        <p>
          We may update these Terms from time to time. Your continued use of the app after updates
          means you accept the updated Terms.
        </p>

        <h2>Contact</h2>
        <p>
          For questions, email{' '}
          <a href="mailto:tnt@northhawks.ca">tnt@northhawks.ca</a>.
        </p>
      </section>
    </div>
  );
}

export default TracknToneTerms;

